if (typeof Highcharts !== "undefined") {
    Highcharts.setOptions({
        lang: {
            months: [
                "Januar",
                "Februar",
                "März",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember",
            ],
            shortMonths: [
                "Jan",
                "Feb",
                "Mrz",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez",
            ],
            thousandsSep: ".",
            decimalPoint: ",",
            loading: "Daten werden geladen",
        },

        chart: {
            className: "click-on-xaxis-title",
            panning: true,
            panKey: "shift",
            style: {
                fontFamily: "Open Sans, sans-serif",
                fontSize: chartFontSizeKlein,
                fontWeight: 300,
            },
            zooming: {
                type: "x",
                resetButton: {
                    theme: {
                        style: {
                            display: "none",
                        },
                    },
                },
                mouseWheel: {
                    enabled: false,
                },
            },
        },

        title: {
            text: "",
        },

        credits: {
            enabled: false,
        },

        navigator: {
            enabled: false,
        },

        scrollbar: {
            enabled: false,
        },

        rangeSelector: {
            enabled: false,
        },

        tooltip: {
            useHTML: true,
            borderRadius: 8,
            pointFormatter: function () {
                if (this.y != 0) {
                    return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 2)}&nbsp;€</span>`;
                } else return false;
            },
            split: true,
            style: {
                color: chartFontColorSchwarz,
                fontSize: chartFontSizeKlein,
            },
        },

        xAxis: {
            type: "datetime",
            labelFormat: "alter", // or datum
            anzeigeFormat: "jahr",
            lineColor: chartFontColorGrau,
            tickColor: chartFontColorGrau,
            labels: {
                align: "center",
                style: {
                    color: chartFontColorGrau,
                    fontSize: chartFontSizeKlein,
                },
                formatter: function () {
                    if (this.axis.options.labelFormat == "datum") {
                        return this.axis.defaultLabelFormatter.call(this);
                    } else {
                        let m = moment(this.value);
                        if (this.dateTimeLabelFormat == "%Y")
                            m = m.endOf("year");
                        return ageLabelFormatter(m);
                    }
                },
            },
            title: {
                text: "Alter (Mandant/Partner)",
                style: {
                    color: chartFontColorGrau,
                    fontSize: chartFontSizeKlein,
                    cursor: "pointer",
                },
            },
            events: {
                setExtremes: function () {
                    // Das Event wird im Chart-Controller bzw. in der Action des ResetButton verarbeitet
                    window.dispatchEvent(new CustomEvent("chart-zooming"));
                },
            },
        },

        yAxis: {
            labels: {
                style: {
                    color: chartFontColorGrau,
                    fontSize: chartFontSizeKlein,
                },
                y: 4,
            },
            title: {
                text: "Euro",
                style: {
                    color: chartFontColorGrau,
                    fontSize: chartFontSizeKlein,
                },
            },
            gridLineColor: "rgba(0, 0, 0, 0.04)",
            opposite: false,
        },

        legend: {
            itemStyle: {
                fontFamily: "Open Sans, sans-serif",
                color: chartFontColorGrau,
                fontSize: chartFontSizeMittel,
                fontWeight: "500",
            },
            itemHoverStyle: {
                color: chartFontColorSchwarz,
            },
            squareSymbol: false,
            symbolRadius: 6,
            symbolWidth: 12,
            symbolHeight: 12,
            itemDistance: 32,
            margin: 16,
            floating: false,
            labelFormatter: function () {
                return this.options.legendName;
            },
        },

        plotOptions: {
            series: {
                legendSymbol: "rectangle",
                marker: {
                    enabled: false,
                    symbol: "circle",
                },
                dataGrouping: {
                    enabled: true,
                    forced: true,
                    groupAll: true,
                    units: [["year", [1]]],
                },
                animation: {
                    duration: chartAnimationDuration,
                    easing: "easeInOut",
                },
                animationLimit: Infinity,
            },
            area: {
                negativeColor: farbeRot,
                lineWidth: 0.5,
                dataGrouping: {
                    approximation: "close",
                },
            },
            arearange: {
                lineWidth: 0.5,
                dataGrouping: {
                    approximation: "averages",
                },
            },
            column: {
                stacking: "normal",
                dataGrouping: {
                    approximation: "sum",
                },
                borderRadius: chartColumnBorderRadius,
            },
            pie: {
                dataLabels: {
                    enabled: false,
                },
            },
            line: {
                // lineWidth: 0.5,
                dataGrouping: {
                    approximation: "close",
                },
            },
        },
    });
}
